import { agentFomoDomain } from "../../constants.ts";
import type { EventEntry } from "../../src/fields.ts";

const adminFetch = async (
  path: string,
  token: string,
  init?: RequestInit,
) => {
  const response = await fetch(`https://${agentFomoDomain}${path}`, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...(init?.headers ?? {}),
    },
  });
  if (!response.ok) {
    throw new Error(await response.text());
  }
  return response.json();
};

export const approveAdminSourceRequest = (token: string, requestId: string) =>
  adminFetch("/admin/source-requests/approve", token, {
    method: "POST",
    body: JSON.stringify({ requestId }),
  });

export const rejectAdminSourceRequest = (
  token: string,
  requestId: string,
  reason?: string,
) =>
  adminFetch("/admin/source-requests/reject", token, {
    method: "POST",
    body: JSON.stringify({ requestId, ...(reason ? { reason } : {}) }),
  });

export const fetchAdminSourceEvents = (
  token: string,
  sourceKind: "instagram-page" | "whatsapp-group" | "link-scrape-source",
  sourceRef: string,
): Promise<EventEntry[]> =>
  adminFetch(
    `/admin/source-events?sourceKind=${sourceKind}&sourceRef=${
      encodeURIComponent(sourceRef)
    }`,
    token,
  );
